/* eslint-disable @typescript-eslint/no-explicit-any */
import { environment } from './../../environments/environment';

export const getEnv = () => {
	return environment;
};

export const getIframesMfesEnv = () => {
	return Object.values(getEnv().iframes);
};

export const getArrayMfesEnv = () => {
	return Object.values(getEnv().mfes);
};

export const getBackEnv = () => {
	if (getEnv().hom) return 'HOM';
	if (!getEnv().production && !getEnv().hom) return 'DEV';
	else return 'PROD';
};

export const isNullOrUndefined = (value: unknown) => {
	return value === undefined || value === null;
};
